import { useState, useEffect } from "react"
import { Link, useNavigate } from "react-router-dom"
import "./Home.css"
import ImageSelect from "../../Auth/ImageSelect"

// A cuisine opens with that cuisine and the shared kitchen essentials ticked
const productsUrl = (category, sub) => {
  const params = new URLSearchParams({ category })
  if (sub) {
    params.append("sub", sub)
    params.append("sub", "essentials")
  }
  return `/products?${params}`
}

const HomeCategories = ({ updated }) => {
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const getCategories = async () => {
      try {
        setLoading(true)
        setError(null)

        const res = await fetch(`${process.env.REACT_APP_API_URL}/categories`)

        if (!res.ok) throw new Error("Failed to fetch categories")

        const data = await res.json()

        // ✅ normalize API response
        const list = Array.isArray(data) ? data : data.categories || []

        setCategories(list)
      } catch (err) {
        console.error(err)
        setError("Failed to load categories")
      } finally {
        setLoading(false)
      }
    }

    getCategories()
  }, [updated])

  /* =========================
     STATES
  ========================= */

  if (loading) {
    return (
      <section className="HomeCategories page-section mt-1">
        <div className="text-center py-5">Loading categories...</div>
      </section>
    )
  }

  if (error) {
    return (
      <section className="HomeCategories page-section mt-1">
        <div className="text-center py-5 text-danger">{error}</div>
      </section>
    )
  }

  if (!categories.length) {
    return (
      <section className="HomeCategories page-section mt-1">
        <div className="text-center py-5">No categories found</div>
      </section>
    )
  }

  /* =========================
     RENDER
  ========================= */

  return (
    <section className="HomeCategories page-section mt-1" id="category">
      <div className="container-fluid col-12 col-md-10 px-3">
        <div className="text-center">
          <h1 className="home-title mb-4">BROWSE CATEGORIES</h1>
        </div>

        <div className="home-category-grid">
          {categories.map((c, index) => {
            // ✅ robust unique key strategy
            const key = c._id || c.category_id || c.id || `${c.name}-${index}`

            return (
              <div key={key}>
                <div className="CategoryCard">
                  <div className="category-img-container">
                    <Link to={productsUrl(c.name)}>
                      <img
                        className="category-img"
                        src={c.image || c.images?.[0] || "/placeholder.png"}
                        alt={c.name || "category"}
                      />
                    </Link>
                  </div>

                  <div className="category-info text-center">
                    <p className="category-name">{c.name || "Unnamed"}</p>

                    {c.subCategories?.length > 0 && (
                      <ImageSelect
                        compact
                        id={`home-type-${key}`}
                        label={`Browse ${c.name} by type`}
                        placeholder="Choose a type…"
                        value=""
                        onChange={(sub) => navigate(productsUrl(c.name, sub))}
                        options={c.subCategories.map((sub) => ({
                          value: sub,
                          label: sub,
                          image: c.subCategoryImages?.[sub],
                        }))}
                      />
                    )}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default HomeCategories
